import styled from 'styled-components';
import breakpoints from 'bdata-sns-shared/mini/utils/miniBreakpoints';
import COLORS from '@mlb/react-patterns/v4/style/universal.color';
import COLORMAP from 'bdata-sns-shared/style/universal.color';

const { mlbWhite, mlbGrey2 } = COLORS;
const { mobile } = breakpoints;

export const MatchupWrapper = styled.div`
    display: flex;
    align-items: center;
    padding-left:0;
    padding: ${({ theme }) => theme.MatchupWrapper.padding};
    ${({ $isPostseason }) => {
        if ($isPostseason) {
            return `
            padding-top: 6px !important;
            `;
        }
    }};
`;

export const PlayerMatchupLayerWrapper = styled.div`
    border-top: 1px solid ${COLORMAP.borderColor};
    margin: 0 8px;

    @media (max-width: ${mobile}) {
        display:none;
    }
`;

export const ContentWrapper = styled.div`
    background: ${mlbWhite};
    transition-duration: .2s;
    border-radius: 5px;
    position: relative;
    height: ${({ theme }) => theme?.contentWrapper?.height};

    ${({ disableCell }) => disableCell ? `
        opacity: 0.5;
        cursor: default;
    ` : ''}

    @media (hover: hover){
        &:hover {
            ${({ disableCell, theme }) => !disableCell ? `border-color: ${theme.hoverBorderColor || mlbGrey2} !important;` : ''}
    }


    @media (max-width: ${mobile}) {
        border-radius: 0;
    }
`;

export const GenericWrapper = styled.div``;
export const GameOuterWrapper = styled.div`
    height: auto;
`;
